// FeaturesBar.jsx
export default function FeaturesBar({
  features = [],
  containerBg = 'lg:bg-[#F5F5F7]',
  iconBg = 'bg-[#F5F5F7] lg:bg-white',
  containerClass = '',
  itemClass = '',
  iconClass = '',
  textClass = '',
}) {
  return (
    <section
      className={`flex flex-wrap justify-center lg:justify-start gap-4 px-4 py-4 w-full lg:w-fit lg:mx-auto rounded-[10px] ${containerBg} ${containerClass}`}
    >
      <div className="grid xl:flex flex-nowrap gap-4">
        {features?.map(({ icon, text }, i) => (
          <div
            key={i}
            className={`flex whitespace-nowrap items-center gap-2 px-4 text-sm ${itemClass}`}
          >
            <img
              src={icon}
              alt={text}
              className={`${iconBg} p-1 rounded-lg ${iconClass}`}
              loading="lazy"
            />
            <span className={textClass}>{text}</span>
          </div>
        ))}
      </div>
    </section>
  );
}